import { render, staticRenderFns } from "./achievements.vue?vue&type=template&id=2b2ad0da&scoped=true&"
import script from "./achievements.vue?vue&type=script&lang=js&"
export * from "./achievements.vue?vue&type=script&lang=js&"
import style0 from "./achievements.vue?vue&type=style&index=0&id=2b2ad0da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2ad0da",
  null
  
)

export default component.exports